const config = {
	serverUrl:
		import.meta.env.VITE_SERVER_URL ||
		"https://webapinew-dev.omnicasa.com/13500.1.0"
};

export default config;
